module.exports = __webpack_public_path__ + "media/images/career_camp/2023/landscape_item_4-3bcbad40ed2aa6a087e3f4faeb520dad.png";